export const CHART_COLOR_CODE = {
  color: [
    '#007873',
    '#1BA39C',
    '#ED7000',
    '#0071DE',
    '#f17924',
    '#D22730',
    '#670026',
    '#C6007E',
    '#F29440',
    '#FFAD00',
    '#BF8200',
    '#4065B8',
    '#e53d32',
    '#971B1F',
    '#3C5A9A',
    '#C63939',
  ],
}
